import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Button from '@components/ui/ButtonV2/Button'
import ShoppingCart from '@components/ui/Icons/ShoppingCart'
import Media from '@components/ui/Media/Media'
import { M47Fragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { useRouter } from 'next/router'
import { CSSProperties, FC } from 'react'
import { ModuleProps } from '..'
import s from './M47.module.scss'
export interface M47Props
  extends Omit<ModuleProps, '__typename'>,
    M47Fragment {}
const M47: FC<M47Props> = ({
  lcp,
  backgroundMedia,
  preHeader,
  exploreCTA,
  buyNowCTA,
  hideBuyNowCTAIcon,
  darkenBackground,
  header,
  heroFontColor,
}) => {
  const router = useRouter()
  return (
    <div
      className={s.root}
      style={{ '--color': heroFontColor ?? undefined } as CSSProperties}
    >
      <div className={s.wrapper}>
        {exploreCTA ? (
          <Link link={exploreCTA} className={s.link}>
            <Media
              mediaWithCrops={backgroundMedia}
              className={clsx({ [s.darken]: darkenBackground })}
              mediaClassName={s.bgMedia}
              priority={lcp}
              disableShopTheLook
            />
          </Link>
        ) : (
          <Media
            mediaWithCrops={backgroundMedia}
            className={clsx(s.link, { [s.darken]: darkenBackground })}
            mediaClassName={s.bgMedia}
            priority={lcp}
            disableShopTheLook
          />
        )}

        <div
          className={s.content}
          style={
            { '--font-color': heroFontColor ?? undefined } as CSSProperties
          }
        >
          <h2 className={s.preHeader}>
            {/* <span className={s.preHeaderIcon}>
            <By />
          </span> */}
            <span>{preHeader}</span>
          </h2>
          <TrustedHtml html={header} className={s.header} />
          {(buyNowCTA || exploreCTA) && (
            <div className={s.btnGroup}>
              {exploreCTA && (
                <Button
                  variant="ghost"
                  className={s.btn}
                  size="small"
                  as={Link}
                  link={exploreCTA}
                >
                  {exploreCTA?.name}
                </Button>
              )}

              {buyNowCTA && (
                <Button
                  variant="buy"
                  className={s.btn}
                  icon={!hideBuyNowCTAIcon && <ShoppingCart />}
                  size="small"
                  as={Link}
                  link={buyNowCTA}
                >
                  {buyNowCTA?.name}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default M47
